document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.m-accordion-row').forEach(function (row) {
    row.addEventListener('click', function () {
      var content = this.nextElementSibling;
      var icon = this.querySelector('.m-accordion-icon');
      if (content && content.classList.contains('m-accordion-content')) {
        content.classList.toggle('open');
        if (icon) icon.textContent = content.classList.contains('open') ? '−' : '+';
      }
    });
  });
  document.querySelectorAll('.m-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.classList.contains('sold-out')) return;
      this.closest('.m-variant-grid').querySelectorAll('.m-variant-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });
  document.querySelectorAll('.m-color-swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      this.closest('.m-color-swatches').querySelectorAll('.m-color-swatch').forEach(function (x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });
  document.querySelectorAll('.m-filter-tag').forEach(function (tag) {
    tag.addEventListener('click', function () {
      this.closest('.m-filters').querySelectorAll('.m-filter-tag').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });
});
